import * as React from "react";
const SvgTableSettings = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path d="M8 3.75A.75.75 0 0 1 8.75 3h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 8 3.75ZM4 15.4a2.926 2.926 0 0 1-.321-.023c-.641-.081-1.55-.457-1.668-1.439a1.364 1.364 0 0 1 .023-.432l1.32-6.6A1.75 1.75 0 0 1 5.07 5.5h13.86a1.75 1.75 0 0 1 1.716 1.407l1.32 6.599c.018.09.046.25.022.437-.127.998-1.083 1.357-1.72 1.434-.088.011-.178.018-.27.021v5.852a.75.75 0 0 1-1.5 0v-6.162a2.44 2.44 0 0 1-.39-.24c-.344-.26-.63-.348-.87-.348-.239 0-.524.088-.868.348-.537.407-1.133.652-1.774.652-.642 0-1.237-.245-1.774-.652-.344-.26-.63-.348-.869-.348-.24 0-.525.088-.869.348-.537.407-1.132.652-1.774.652-.641 0-1.237-.245-1.774-.652-.344-.26-.63-.348-.869-.348-.24 0-.525.088-.868.348a2.458 2.458 0 0 1-.299.193v6.209a.75.75 0 0 1-1.5 0V15.4Zm11.465-1.748c.537-.407 1.132-.652 1.774-.652.641 0 1.237.245 1.774.652.236.179.671.285 1.074.236a.897.897 0 0 0 .4-.131l-1.312-6.556A.25.25 0 0 0 18.93 7H5.07a.25.25 0 0 0-.245.201L3.51 13.767a.775.775 0 0 0 .356.121c.37.047.784-.052 1.026-.236.538-.407 1.133-.652 1.774-.652.642 0 1.237.245 1.774.652.344.26.63.348.87.348.239 0 .524-.088.868-.348.537-.407 1.133-.652 1.774-.652.642 0 1.237.245 1.774.652.344.26.63.348.869.348.24 0 .525-.088.869-.348Z" />
    </g>
  </svg>
);
export default SvgTableSettings;
